import React, {Component} from 'react';
import {Redirect} from 'react-router-dom';
import InfoCircle from '../../common/InfoCircle';
import InviteAdminsModal from '../../modals/InviteAdminsModal';
import TeamsModals from '../../modals/TeamsModals';
import TeamTable from './TeamTable';
import $ from 'jquery';
import toastr from 'toastr';

import {PopoverInteractionKind, Position, Popover} from "@blueprintjs/core";
import UpsellModalTailwind from "../../modals/UpsellModalTailwind";


class TeamTablesManage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            display: "none",
            clicked_id: "",
            clicked_index: "",
            sortColumn: {
                path: "name",
                order: "asc"
            },
            clicked_team_display: "",
            redirect: false,
            project_id: '',
            project_name: '',
            selectedProject: '',
            selectedProjectName: '',
            selectedAdmin: '',
            isPendingAdmin: false,
            renameTeamModalVisible: false,
            deleteTeamModalVisible: false,
            removeAdminFromTeamModalVisible: false,
            removeAdminFromProjectModalVisible: false,
            reassignProjectModalVisible: false,
            team: '',
            limitsReached: this.props.limitsReached,
            selectedSource: this.props.selectedSource,
            upsellModalVisible: false,
            upgradeModalTitle: '',
            upgradeModalContent: '',
            selectedPlan: ''
        };
    }

    handlePageChange = page => {
        this.setState({currentPage: page})
    };

    handleSort = (sortColumn) => {
        this.setState({sortColumn})
    };
    getSelectedPlan = async () => {
        //console.log('entered selected plan')
        let user = await this.props.user;
        let projectId = await this.state.selectedSource;
        let project = await user.sources.data.find(project => projectId.toString() === project.id.toString());

        //console.log('getSelectedPlan project: ', project);

        this.setState({
            selectedPlan: project && project.plan && project.plan.plan_id ? project.plan.plan_id : ''
        })
    }

    openDescription = (e) => {
        const descPanel = e.target.nextSibling;
        if (descPanel.classList.contains('d-block')) {

            descPanel.classList.remove('d-block');
        } else {
            descPanel.classList.add('d-block');
        }
    };

    closeDescription = (e) => {
        const descPanel = e.target.parentElement;
        if (descPanel.classList.contains('d-block')) {

            descPanel.classList.remove('d-block');
        } else {
            descPanel.classList.add('d-block');
        }
    };

    addFeedFromTeam = (e) => {
        //console.log("addFeedFromTeam e.target", e.target);
        this.setState({redirect: true})
    };

    toggleMemberData = (e) => {
        //console.log("toggleMemberData e.target", e.target);
        this.setState({
            clicked_id: e.target.id,
            clicked_index: e.target.name || e.target.title
        });
        if (this.state.display === "none") {
            this.setState({display: "block"});
        } else {
            this.setState({display: "none"})
        }
    };

    handleFeedMenu = (e) => {
        this.setState({
            clicked_team_display: this.state.clicked_team_display.toString() === e.target.title ? '' :
                e.target.title === this.props.team.team_name ? this.state.clicked_team_display : e.target.title
        });
        $('.feed-dropdown-' + e.target.title).toggle();
    };

    openModalForTeam = async (e) => {
        // console.log("toggleMemberData this.props.team", this.props.team);
        // alert("openModalForTeam");
        //localStorage.setItem("team_clicked", JSON.stringify(this.props.team));
        this.props.openModal(e, this.props.team);
    };

    addDefaultSrc = (ev) => {
        ev.target.src = 'https://4.bp.blogspot.com/-zsbDeAUd8aY/US7F0ta5d9I/AAAAAAAAEKY/UL2AAhHj6J8/s640/facebook-default-no-profile-pic.jpg';
    }

    checkTeamsForFreeProjects = async () => {
        let projects = this.props.sources;
        let teamProjects = await this.props.team.feeds.length ? this.props.team.feeds : [];
        let updatedTeamProjects = [];
        let team = this.props.team;
        let hasProProjectSubscription = false;

        await teamProjects.map(teamProject => projects.map(project => project.id === teamProject.id ?
            (
                updatedTeamProjects = [
                    ...updatedTeamProjects,
                    {
                        ...teamProject,
                        team_members: project && project.plan && project.plan.team_members ? project.plan.team_members : ''
                    }
                ],
                    project && project.plan && project.plan.team_members && project.plan.team_members !== '1' ? hasProProjectSubscription = true : ''
            )
            :
            ''
        ));

        team = await {
            ...this.props.team,
            feeds: updatedTeamProjects,
            hasProProjectSubscription
        }
        await this.setState({team})
    }
    addTeamMember = (teamId) => {
        //console.log('teamId: ', teamId)
        let teamLimits = this.state.limitsReached.find(teamData => {
            return teamData.id === teamId
        })
        //console.log('teamLimits: ', teamLimits)

        if (!teamLimits.teamLimitReached) {
            this.setState({addTeamAdminModalVisible: true})
        } else {
            this.setState({
                upsellModalVisible: true,
                upgradeModalTitle: 'You reached limited number of users in team "' + teamLimits.name + '"',
                upgradeModalContent: 'Check out the plans and features below and choose the one that suits your needs.'
            })
        }

    }
    addProjectAdmin = async (projectId, projectName, teamId) => {
        // console.log('projectId: ', projectId)
        // console.log('projectName: ', projectName)
        // console.log('teamId: ', teamId)
        let teamLimits = this.state.limitsReached.find(teamData => {
            return teamData.id === teamId
        })
        //console.log('teamLimits: ', teamLimits)
        let workspaceLimits = teamLimits.workspaces.find(workspaceData => {
            return workspaceData.id === projectId
        })
        //console.log('workspaceLimits: ', workspaceLimits)

        if (workspaceLimits.workspaceLimitReached === true) {
            this.setState({
                upsellModalVisible: true,
                upgradeModalTitle: 'You reached limited number of users on workspace "' + workspaceLimits.name + '"',
                upgradeModalContent: 'Check out the plans and features below and choose the one that suits your needs.'
            })
        } else {
            this.setState({
                    selectedProject: projectId,
                    selectedProjectName: projectName,
                    addProjectAdminModalVisible: true
                }
            )
        }
    }
    componentDidMount = () => {
        this.checkTeamsForFreeProjects()
        this.getSelectedPlan()
    }

    componentDidUpdate = () => {
        if (this.props.team && this.props.team.feeds && this.props.team.feeds && this.state.team && this.state.team.feeds &&
            (this.props.team.feeds.length !== this.state.team.feeds.length)) {
            this.checkTeamsForFreeProjects()
        }
        if (this.state.limitsReached !== this.props.limitsReached) {
            this.setState({
                limitsReached: this.props.limitsReached
            })
        }
        if (this.state.selectedSource !== this.props.selectedSource) {
            this.setState({
                selectedSource: this.props.selectedSource
            })
        }
        if (!this.state.selectedPlan) {
            this.getSelectedPlan()
        }
    }

    render() {
        const {team} = this.props;

        if (this.state.redirect) {
            return (
                <Redirect to={{pathname: '/feed', state: {team: team}}}/>
            )
        }
        // console.log('team: ', team)
        return (
            <div className="team-card panel-container m-m-b teams-tour-step-2">
                <div className="team-header">
                    <h3>{team.team_name}</h3>
                    <div className="feed-menu">
                        <Popover
                            interactionKind={PopoverInteractionKind.CLICK}

                            position={Position.LEFT_TOP}
                            minimal={true}
                        >
                            <span className="fas fa-ellipsis-v"></span>
                            <div className="three-dots-popover padding-10">
                                <a href="# " id="team_edit_btn" title={team.team_name} name={team.id}
                                   onClick={() => this.setState({renameTeamModalVisible: true})}>Edit</a>
                                <a href="# " id="team_delete_btn" title={team.team_name} name={team.id}
                                   onClick={() => this.setState({deleteTeamModalVisible: true})}>Delete</a>
                            </div>
                        </Popover>
                    </div>
                </div>
                <div className="team-body" data-intercom-target="teams-feed-team-body">
                    <div className="team-admins">
                        <div className="admins-header-container">
                            <div>
                                <span className="team-subtitle">Team Admins</span>
                                <InfoCircle
                                    icon='question'
                                    infoCircleContent={
                                        <p className='info-circle-content'><strong>Team Admins</strong> <br/>
                                            Can manage all workspaces within a team.</p>
                                    }
                                />
                            </div>
                            {/*{*/}
                            {/*    (this.props.user.user_type === 'reseller') &&*/}

                            <div className='add-team-admin' onClick={() => this.addTeamMember(team.id)}>
                                <a href='#' title={team.team_name} id="add_admin" slot={team.id}
                                   className="add-new teams-tour-step-1">
                                    + Add team admin
                                </a>
                            </div>


                        </div>
                        <div className="separator"></div>
                        <div className="display-flex">
                            <div className="col-xs-12">

                                {team.admins && team.admins.map((admin, index) =>

                                    <div key={index} id={index} className="team-user" onClick={this.toggleMemberData}>


                                        <div id={admin.id}
                                             title={admin.first_name + " " + admin.last_name}
                                             className="team-user-panel ">

                                            <div className="team-admin-pic">
                                                <img src={admin.profile_photo || "/img/default-user.jpg"} alt="user"
                                                     onError={this.addDefaultSrc}/>
                                            </div>
                                            <div className="team-admin-about">
                                                <div
                                                    className="team-user-name">{(admin.first_name || '') + " " + (admin.last_name || '')}</div>
                                                <div className="team-user-email">{admin.email}</div>
                                            </div>
                                        </div>
                                        <div className="platform-menu feed-edit">
                                            <Popover
                                                interactionKind={PopoverInteractionKind.CLICK}
                                                className={this.state.removeAdminFromTeamModalVisible ? 'd-none' : ''}
                                                position={Position.LEFT_TOP}
                                                minimal={true}
                                            >

                                                <span className="fas fa-ellipsis-v"></span>
                                                <div
                                                    className={this.state.removeAdminFromTeamModalVisible ? 'd-none' : ''}>
                                                    <div className="three-dots-popover padding-10 ">
                                                        {team.admins.length === 1 ?
                                                            <a id="team_delete_btn"
                                                               onClick={() => toastr.info("You can't delete the last admin from the team. " +
                                                                   "You can either delete the whole team or add a new admin and then delete yourself.")}
                                                               href="#">Remove from team</a>
                                                            :
                                                            <a id="team_delete_btn" title={team.id} name={admin.id}
                                                               slot={(admin.first_name || '') + " " + (admin.last_name || '')}
                                                               onClick={() => this.setState({
                                                                   removeAdminFromTeamModalVisible: true,
                                                                   selectedAdmin: admin,
                                                                   isPendingAdmin: false
                                                               })}
                                                               href="#">Remove from team</a>
                                                        }
                                                    </div>
                                                </div>
                                            </Popover>
                                        </div>
                                    </div>
                                )}
                                {team.pending_admins && team.pending_admins.map((pending_admin, index) =>
                                    <div id={pending_admin.id} key={index} className="team-user"
                                         onClick={this.toggleMemberData}>


                                        <div className="team-user-panel reg-pending-panel">
                                            <span className="pending-reg"></span>
                                            <div className="team-admin-about">
                                                <div
                                                    className="team-user-name">{pending_admin.name || pending_admin.email}</div>
                                                <div className="team-user-email">Registration pending</div>
                                            </div>
                                        </div>

                                        <div className="platform-menu feed-edit ">
                                            <Popover
                                                interactionKind={PopoverInteractionKind.CLICK}


                                                position={Position.LEFT_TOP}
                                                minimal={true}
                                            >
                                                <span className="fas fa-ellipsis-v"></span>
                                                <div
                                                    className={this.state.removeAdminFromTeamModalVisible ? 'd-none' : ''}>
                                                    <div className="three-dots-popover padding-10">
                                                        <a href="#" title={team.id}
                                                           name={pending_admin.id}
                                                           slot={pending_admin.email}
                                                           id="remove_pending_from_team"

                                                           onClick={() => this.setState({
                                                               removeAdminFromTeamModalVisible: true,
                                                               selectedAdmin: pending_admin,
                                                               isPendingAdmin: true
                                                           })}>Remove from team</a>
                                                    </div>
                                                </div>
                                            </Popover>
                                        </div>
                                    </div>
                                )}


                            </div>
                        </div>
                    </div>
                    <div className="admins-header-container">
                        <div>
                            <span className="team-subtitle">Workspaces</span>
                            <InfoCircle
                                icon='question'
                                infoCircleContent={
                                    <p className='info-circle-content'><strong>Workspaces</strong> <br/>
                                        A group of online resources that<br/> you want to manage and automate.</p>
                                }
                            />
                        </div>
                        <div className='add-team-admin'
                             onClick={() => {
                                 localStorage.setItem("selectedTeam", team.id);
                                 localStorage.setItem("navigateBackTo", '/teams');
                                 this.props.history.push('/workspace-name', {teamSelected: team.id})
                             }}>
                            <a title={team.team_name} id="add_admin" slot={team.id}
                               className="add-new">
                                + Add a new workspace
                            </a>
                        </div>

                    </div>

                    <div className="separator"></div>
                    {/*{console.log('teams: ', this.state.team, this.state.team.feeds, team.feeds)}*/}
                    {team.feeds.length ?

                        <TeamTable
                            feeds={this.state.team && this.state.team.feeds && this.state.team.feeds.length ? this.state.team.feeds : team.feeds}
                            user={this.props.user}
                            name={team.team_name}
                            team_id={team.id}
                            sources={this.props.sources}
                            sortColumn={this.state.sortColumn}
                            onClick={this.handleClick}
                            onSort={this.handleSort}
                            activateAddProjectAdminModal={
                                (projectId, projectName) => this.addProjectAdmin(projectId, projectName, team.id)
                                // async (projectId, projectName) => {
                                //     await this.setState({
                                //         selectedProject: projectId,
                                //         selectedProjectName: projectName,
                                //         addProjectAdminModalVisible: true
                                //     })
                                //     // console.log('Ja sam opalio activateAddProjectAdminModal: ',this.props.type, projectId, this.state.selectedProject)
                                // }
                            }
                            activateRemoveProjectAdminModal={(projectId, projectName, selectedAdmin, isPendingAdmin) => this.setState({
                                removeAdminFromProjectModalVisible: true,
                                selectedAdmin,
                                isPendingAdmin,
                                selectedProject: projectId,
                                selectedProjectName: projectName
                            })}
                            activateReassignProjectToTeamModal={(projectId, projectName) => this.setState({
                                reassignProjectModalVisible: true,
                                selectedProject: projectId,
                                selectedProjectName: projectName
                            })}
                        />


                        :
                        <div>
                            <div className="text-center">
                                <h2 className="text-center ">You have no workspaces associated with this team!</h2>
                                <button type="button" className='btn-m btn-action'
                                        onClick={() => {
                                            localStorage.setItem("selectedTeam", team.id);
                                            localStorage.setItem("navigateBackTo", '/teams');
                                            this.props.history.push('/workspace-name', {teamSelected: team.id})
                                        }}>
                                    Add a new workspace
                                </button>
                            </div>
                        </div>
                    }
                </div>
                {/*{console.log('SelectedProject: ', this.props.type, this.state.selectedProject)}*/}
                <InviteAdminsModal
                    showModal={this.state.addTeamAdminModalVisible}
                    type={'teamAdmin'}
                    width={500}
                    handleClose={async () => {
                        await this.setState({addTeamAdminModalVisible: false})
                        await this.props.updateUserFromServer();
                        await this.props.getTeams();
                        await this.checkTeamsForFreeProjects()
                    }}
                    history={this.props.history}
                    team_name={team.team_name}
                    team_id={team.id}
                    projectId={this.state.selectedProject}
                    project_name={this.state.selectedProjectName}
                    user={this.props.user}
                    getTeams={this.props.getTeams}
                />
                <InviteAdminsModal
                    showModal={this.state.addProjectAdminModalVisible}
                    type={'projectAdmin'}
                    width={500}
                    handleClose={async () => {
                        await this.setState({addProjectAdminModalVisible: false})
                        await this.props.updateUserFromServer();
                        await this.props.getTeams();
                        await this.checkTeamsForFreeProjects()
                    }}
                    history={this.props.history}
                    team_name={team.team_name}
                    team_id={team.id}
                    projectId={this.state.selectedProject}
                    project_name={this.state.selectedProjectName}
                    user={this.props.user}
                    getTeams={this.props.getTeams}
                />
                <TeamsModals
                    showModal={this.state.renameTeamModalVisible}
                    type={'renameTeam'}
                    width={500}
                    handleClose={async () => {
                        await this.setState({renameTeamModalVisible: false})
                        await this.props.updateUserFromServer();
                        await this.props.getTeams();
                        await this.checkTeamsForFreeProjects();
                    }}
                    history={this.props.history}
                    team_name={team.team_name}
                    team_id={team.id}
                    project_id={this.state.selectedProject}
                    project_name={this.state.selectedProjectName}
                    user={this.props.user}
                    getTeams={this.props.getTeams}
                />
                <TeamsModals
                    showModal={this.state.deleteTeamModalVisible}
                    type={'deleteTeam'}
                    width={500}
                    handleClose={async () => {
                        await this.setState({deleteTeamModalVisible: false})
                        await this.props.updateUserFromServer();
                        await this.props.getTeams();
                        await this.checkTeamsForFreeProjects();
                    }}
                    history={this.props.history}
                    team_name={team.team_name}
                    team_id={team.id}
                    project_id={this.state.selectedProject}
                    project_name={this.state.selectedProjectName}
                    user={this.props.user}
                    getTeams={this.props.getTeams}
                />
                <TeamsModals
                    showModal={this.state.removeAdminFromTeamModalVisible}
                    type={'removeAdminFromTeam'}
                    width={500}
                    handleClose={async () => {
                        await this.setState({removeAdminFromTeamModalVisible: false})
                        await this.props.updateUserFromServer();
                        await this.props.getTeams();
                        await this.checkTeamsForFreeProjects();
                    }}
                    history={this.props.history}
                    team_name={team.team_name}
                    team_id={team.id}
                    project_id={this.state.selectedProject}
                    project_name={this.state.selectedProjectName}
                    selectedAdmin={this.state.selectedAdmin}
                    isPendingAdmin={this.state.isPendingAdmin}
                    user={this.props.user}
                    getTeams={this.props.getTeams}
                />
                <TeamsModals
                    showModal={this.state.removeAdminFromProjectModalVisible}
                    type={'removeAdminFromProject'}
                    width={500}
                    handleClose={async () => {
                        await this.setState({removeAdminFromProjectModalVisible: false})
                        await this.props.updateUserFromServer();
                        await this.props.getTeams();
                        await this.checkTeamsForFreeProjects();
                    }}
                    history={this.props.history}
                    team_name={team.team_name}
                    team_id={team.id}
                    project_id={this.state.selectedProject}
                    project_name={this.state.selectedProjectName}
                    selectedAdmin={this.state.selectedAdmin}
                    isPendingAdmin={this.state.isPendingAdmin}
                    user={this.props.user}
                    getTeams={this.props.getTeams}
                />
                <TeamsModals
                    showModal={this.state.reassignProjectModalVisible}
                    type={'reassignProject'}
                    width={500}
                    handleClose={async () => {
                        await this.setState({reassignProjectModalVisible: false})
                        await this.props.updateUserFromServer();
                        await this.props.getTeams();
                        await this.checkTeamsForFreeProjects();
                    }}
                    history={this.props.history}
                    teams={this.props.teams.data}
                    teams_in={this.props.teams_in.data}
                    team_name={team.team_name}
                    team_id={team.id}
                    project_id={this.state.selectedProject}
                    project_name={this.state.selectedProjectName}
                    user={this.props.user}
                    getTeams={this.props.getTeams}
                />
                <UpsellModalTailwind
                    selectedSource={this.state.selectedSource}
                    showModal={this.state.upsellModalVisible}
                    handleClose={() => this.setState({upsellModalVisible: false})}
                    maxWidth={null}
                    history={this.props.history}
                    title={this.state.upgradeModalTitle}
                    content={this.state.upgradeModalContent}
                    plan={this.state.selectedPlan}
                    user={this.props.user}
                />
            </div>
        );
    }
}

export default TeamTablesManage